import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  display: inline-flex;\n  margin: 0 -', 'px;\n'], ['\n  display: inline-flex;\n  margin: 0 -', 'px;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  flex: 1 0 auto;\n  margin: 0 ', 'px;\n'], ['\n  flex: 1 0 auto;\n  margin: 0 ', 'px;\n']);

import styled from 'styled-components';

var gutter = 4;

export default styled.div(_templateObject, gutter / 2);

export var GroupItem = styled.div(_templateObject2, gutter / 2);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/modal-dialog/node_modules/@atlaskit/button/dist/esm/styled/ButtonGroup.js
// module id = 823
// module chunks = 0